import type { QueryResult, VisualizationConfig } from "./types";
export function visualizationError(
  data: QueryResult,
  config: VisualizationConfig,
): string | undefined {
  if (config.type === "table")
    return config.columns &&
      (!config.columns.length ||
        config.columns.some((c) => !data.columns.includes(c)))
      ? "Choose at least one available table column."
      : undefined;
  if (data.fields.some((f) => ["array", "record"].includes(f.type)))
    return "Use a table for nested results.";
  if (
    !config.y.length ||
    config.y.some(
      (name) => data.fields.find((f) => f.name === name)?.type !== "number",
    )
  )
    return "Choose numeric chart values from the query results.";
  if (config.type === "kpi")
    return config.y.length !== 1
      ? "A KPI requires exactly one numeric value."
      : data.rows.length > 1
        ? "KPI requires one result row. Remove grouping or use a table."
        : undefined;
  if (!data.columns.includes(config.x))
    return "Choose an X-axis field from the query results.";
  if (
    new Set(
      config.y.map(
        (name) =>
          config.fieldFormats?.[name] ??
          data.fields.find((f) => f.name === name)?.format ??
          config.format,
      ),
    ).size > 1
  )
    return "Choose chart values with matching units, or use a table.";
  if (config.type === "pie" && config.y.length !== 1)
    return "A pie chart requires one numeric value.";
}
